import React from "react";
import {
  Users, Headset, Rocket, Banknote, ShieldCheck, Sparkles, Building2,
  Handshake, BarChart3, Settings, Layers, Globe, Zap, Award, Lock, LifeBuoy,
} from "lucide-react";

const MAP = {
  Users, Headset, Rocket, Banknote, ShieldCheck, Sparkles, Building2,
  Handshake, BarChart3, Settings, Layers, Globe, Zap, Award, Lock, LifeBuoy,
};

export const ENTERPRISE_ICON_NAMES = Object.keys(MAP);

export function EnterpriseIcon({ name, className }) {
  const Ic = MAP[name] || Users;
  return <Ic className={className} />;
}
